import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';
import { FeatureStatus } from '../types';

export function useFeatureStatus() {
  return useQuery<FeatureStatus>({
    queryKey: ['features', 'status'],
    queryFn: async () => {
      try {
        return await apiService.getFeatureStatus();
      } catch {
        // Fail closed: backend may not yet expose this endpoint.
        return { converter_web: false, converter_api: false } as FeatureStatus;
      }
    },
    staleTime: 30_000,
  });
}

export interface ConverterFeatures {
  web: boolean;
  api: boolean;
  isLoading: boolean;
}

export function useConverterFeatures(): ConverterFeatures {
  const { data, isLoading } = useFeatureStatus();
  return { web: !!data?.converter_web, api: !!data?.converter_api, isLoading };
}
